import i18n from '@/i18n/i18n'
import {getErrorMessage, ERROR_MESSAGE_MAP} from '@/helpers/errorMessage'

const showToastError = (dispatch, message, isI18n = false) => {
  const finalMessage = isI18n ? i18n.t(message) : message
  dispatch('SHOW_TOAST_ERROR', finalMessage, {root: true})
}

const customErrors = async (err, dispatch, customMessage) => {
  // Безопасное извлечение данных из ошибки
  const {response, code: networkCode} = err || {}
  const {data = {}} = response || {}
  const {code, type} = data
  const combinedMessage = getErrorMessage(code, ERROR_MESSAGE_MAP)

  if (combinedMessage) {
    showToastError(dispatch, combinedMessage)
    return
  }

  // Кастомное сообщение от вызывающего кода
  if (customMessage) {
    showToastError(dispatch, customMessage, true)
    return
  }

  // Fallback: сообщение от сервера или техническая информация
  const isDev = process.env.VUE_APP_MODE === 'development'
  const fallbackMessage = isDev
    ? `${type || 'Unknown type'}: ${networkCode || 'Unknown error'}`
    : networkCode || 'Unknown error'

  showToastError(dispatch, fallbackMessage)
}

export default customErrors
